<app-public-navigation/>

<div class="features-page container py-5">
  <h1 class="mb-4 text-center">Funktionen</h1>
  <p class="lead text-center mb-5">
    TaskRadar bündelt alle wichtigen Werkzeuge für eine effiziente, transparente und teamfähige Aufgabenverwaltung –
    von klaren Statusabläufen über flexible Typen bis hin zu Erinnerungen, Archivierung und einer starken Stammdatenbasis.
  </p>

  <div class="row g-4">
    <div class="col-md-6 col-lg-4" *ngFor="let f of features">
      <div class="feature-card p-4 h-100">
        <div class="icon mb-3"><i class="fa-solid {{ f.icon }}" [style.color]="f.color" aria-hidden="true"></i></div>
        <h3 class="h5">{{ f.title }}</h3>
        <p class="mb-0">{{ f.desc }}</p>
      </div>
    </div>
  </div>

  <div class="text-center mt-4">
    <a class="btn btn-danger btn-lg" href="mailto:kontakt@noteradar.at" aria-label="Zugang anfordern per E-Mail">Jetzt Zugang anfordern</a>
  </div>

  <hr class="my-5" />

  <div class="links text-center">
    <a routerLink="/landing" class="btn btn-outline-secondary me-2"><i class="fa-solid fa-house"></i> Startseite</a>
    <a routerLink="/price" class="btn btn-outline-primary"><i class="fa-solid fa-tags"></i> Preise</a>
  </div>
</div>

<app-public-footer></app-public-footer>
